import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="38"
    height="12"
    viewBox="0 0 38 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5592 11.4736H13.6008L15.4498 0.293523H18.4085L16.5592 11.4736ZM11.112 0.293523L8.29154 7.9833L7.9578 6.32739L7.9581 6.32799L6.96263 1.30017C6.96263 1.30017 6.84226 0.293523 5.55925 0.293523H0.89651L0.841797 0.482829C0.841797 0.482829 2.26767 0.774713 3.93641 1.76072L6.50669 11.4739H9.58915L14.296 0.293523H11.112ZM34.3816 11.4736H37.0981L34.7296 0.293224H32.3515C31.2533 0.293224 30.9858 1.12641 30.9858 1.12641L26.5735 11.4736H29.6575L30.2742 9.81296H34.0351L34.3816 11.4736ZM31.1262 7.51886L32.6807 3.33498L33.5551 7.51886H31.1262ZM26.8048 2.98209L27.227 0.58122C27.227 0.58122 25.9242 0.09375 24.5661 0.09375C23.098 0.09375 19.6116 0.725069 19.6116 3.79494C19.6116 6.68328 23.7035 6.71917 23.7035 8.23631C23.7035 9.75345 20.0332 9.4816 18.8219 8.5249L18.3821 11.0352C18.3821 11.0352 19.7031 11.6665 21.7214 11.6665C23.7403 11.6665 26.786 10.6381 26.786 7.83885C26.786 4.93197 22.6573 4.66132 22.6573 3.39749C22.6576 2.13335 25.5388 2.29574 26.8048 2.98209Z"
      fill="#2566AF"
    />
    <path
      d="M7.9581 6.32744L6.96263 1.29961C6.96263 1.29961 6.84226 0.292969 5.55925 0.292969H0.89651L0.841797 0.482275C0.841797 0.482275 3.08289 0.939241 5.23249 2.65137C7.28787 4.28784 7.9581 6.32744 7.9581 6.32744Z"
      fill="#E6A540"
    />
  </SvgIcon>
));
